/*  ========================================================================
    # Scripts - Text Reveal
    ========================================================================  */

/**
 * Script that automatically finds all .u-text-reveal elements and takes care of the scroll-triggered reveal animation
 */

import { animate, stagger, inView } from 'motion';

const TextReveal = {
  cfg: {
    items: document.querySelectorAll('.u-text-reveal')
  },

  prepareItems() {
    // If the user prefers reduced motion, do not animate anything and stop right here
    if (window.prefersReducedMotion) return;

    // We can safely continue with animation
    this.cfg.items.forEach(item => {
      const textToAnimate = item.textContent;

      // Clear the element itself
      item.innerHTML = '';

      // Create a screenreader-only replica that is not visible to regular users
      const sronly = document.createElement('span');
      sronly.innerText = textToAnimate;
      sronly.setAttribute('class', 'u-screenreader');
      item.appendChild(sronly);

      // Now insert the actual text back, but wrap every word in its own span to achieve the animation effect
      const words = textToAnimate.split(' ');
      words.forEach(word => {
        const span = document.createElement('span');
        span.innerText = word + ' ';
        span.setAttribute('aria-hidden', 'true');
        item.appendChild(span);
      });

      inView(
        item,
        info => {
          animate(
            info.target.querySelectorAll('span'),
            { color: 'var(--text-reveal-to)' },
            { type: 'keyframes', duration: 0.5, delay: stagger(0.15) }
          );
        },
        { amount: 0.5 }
      );
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.items.length > 0) {
      this.prepareItems();
    }
  }
};

export default TextReveal;
